module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Account Details")]), _vm._v(" "), (_vm.loadState === 'loading') ? _c('div', [_c('Loader', {
    attrs: {
      "size": 'large'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loadState === 'error') ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.accountError))])]) : _vm._e(), _vm._v(" "), (_vm.loadState === 'success') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "four columns statname"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "eight columns"
  }, [_vm._v(_vm._s(this.stats.username))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "four columns statname"
  }, [_vm._v("Invited By")]), _vm._v(" "), _c('div', {
    staticClass: "eight columns"
  }, [_vm._v(_vm._s(this.stats.invited_by || '[Original User]'))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "four columns statname"
  }, [_vm._v("Posts Made")]), _vm._v(" "), _c('div', {
    staticClass: "eight columns"
  }, [_vm._v(_vm._s(this.stats.posts_made))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "four columns statname"
  }, [_vm._v("Votes Cast")]), _vm._v(" "), _c('div', {
    staticClass: "eight columns"
  }, [_vm._v(_vm._s(this.stats.votes_cast))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "four columns statname"
  }, [_vm._v("Winning Suggestions")]), _vm._v(" "), _c('div', {
    staticClass: "eight columns"
  }, [_vm._v(_vm._s(this.stats.times_won))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Invite Friends")]), _vm._v(" "), _c('p', [_vm._v("For now, users have to be invited to participate in Lost In Space by someone already on the platform. This maintains the friendliness of the site, and drastically cuts spam.")]), _vm._v(" "), _c('p', [_vm._v("To invite someone to the platform, send them your (personalized) referral link, below:")]), _vm._v(" "), _c('input', {
    staticClass: "u-full-width",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.getLink()
    },
    on: {
      "click": function($event) {
        _vm.selectLink($event)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Or, they can register manually by entering the following token when they register on the Login page:")]), _vm._v(" "), _c('input', {
    staticClass: "u-full-width",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.inviteToken
    },
    on: {
      "click": function($event) {
        _vm.selectLink($event)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Think your token's been stolen? Just click the button below to invalidate your old token and regenerate a new one!")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.regenerate
    }
  }, [_vm._v("Regenerate Token")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-645f38d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
// module id = 277
// module chunks = 1